type SegmentItem = {
  name: string;
  segmentId: string;
};

export type GeoMultiMethodItem = {
  multiMethodId: string;
  publicName: string;
  imageId: string | null;
  filePath: string | null;
  withdrawalAvailable: boolean;
  currency: string;
  country: string;
  enabled: boolean;
  organic: boolean;
  sortingWeight: number | null;
  segmentList: SegmentItem[];
  excludedSegmentList: SegmentItem[];
  depositRange: { min: number; max: number };
  withdrawalRange: { min: number; max: number };
};

export const GEO_MULTI_METHOD_DEFAULT_STATE: GeoMultiMethodItem = {
  multiMethodId: '',
  publicName: '',
  imageId: '',
  filePath: '',
  withdrawalAvailable: false,
  currency: '',
  country: '',
  enabled: false,
  organic: true,
  sortingWeight: null,
  segmentList: [],
  excludedSegmentList: [],
  depositRange: { min: 0, max: 0 },
  withdrawalRange: { min: 0, max: 0 },
};

export type GeoMultiMethodCreateRequestPayload = {
  publicName: string;
  imageId: string | null;
  withdrawalAvailable: boolean;
  currency: string;
  country: string;
  organic: boolean;
  segmentList: SegmentItem[];
  excludedSegmentList: SegmentItem[];
}

export type GeoMultiMethodUpdateRequestPayload = {
  multiMethodId: string;
  publicName: string;
  imageId: string;
  depositAvailable?: boolean;
  withdrawalAvailable: boolean;
  currency: string;
  country: string;
  enabled: boolean;
  organic: boolean;
  sortingWeight: number;
  segmentList: SegmentItem[];
  excludedSegmentList: SegmentItem[];
};

export type DisassociateBillingMethodRequestPayload = {
  multiMethodId: string;
  billingPaymentMethodId: string;
};

export type AssociateBillingMethodRequestPayload = {
  multiMethodId: string;
  payloadData: {
    billingPaymentMethodIdList: string[];
  };
};

export type AvailableAssociablePaymentMethodItem = {
  billingPaymentMethodId: string;
  name: string;
  imageId: string;
  filePath: string;
};

export type AssociatedPaymentMethodItem = {
  billingPaymentMethodId: string;
  name: string;
  imageId: string;
  filePath: string;
  withdrawalRangeMin: number;
  withdrawalRangeMax: number;
  depositRangeMin: number;
  depositRangeMax: number;
  active: boolean;
};

export type UpdateAssociatedPaymentMethodRequestPayload = {
  multiMethodId: string;
  associatedBillingMethodData: AssociatedPaymentMethodItem;
}

export type CreateGeoMultiMethodResponce = {
  data: {};
  headers: {
    'Content-Location': string;
  };
}
